import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MbscEventcalendarOptions } from '@mobiscroll/angular';
import moment from 'moment';
import { DateType } from 'src/app/shared/components/inputs/date-time/date-time.component';

@Component({
  selector: 'swodoc-node-date',
  templateUrl: 'swodoc-node-date.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SwodocNodeDate implements OnInit {
  @Input()
  public node: any;
  public displayValue: string;
  public options: MbscEventcalendarOptions;
  public type: DateType = DateType.DateTime;
  private _date: Date;

  @Output()
  changed: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit(): void {
    if (this.node.options) {
      if (this.node.options.date && this.node.options.time) {
        this.type = DateType.DateTime;
      }
      if (this.node.options.date && !this.node.options.time) {
        this.type = DateType.Date;
      }
      if (!this.node.options.date && this.node.options.time) {
        this.type = DateType.Time;
      }
    }
    if (this.node.responses && this.node.responses.length > 0 && this.node.responses[0].value) {
      this._date = new Date(this.node.responses[0].value);
    }
  }

  get maxDate(): string {
    return new Date(new Date().getFullYear() + 20, 11, 31).toISOString();
  }
  get date(): Date {
    return this._date ? this._date : null;
  }
  set date(date: Date) {
    if (!date || !(date instanceof Date) || !moment(date).isValid()) {
      this.node.responses = null;
      this._date = null;
      this.changed.emit(this.node);
      return;
    }
    if (this._date) {
      this._date.setTime(date.getTime());
    }
    const isoString = moment(date).format();
    this.node.responses = [{ value: isoString }];
    this.changed.emit(this.node);
  }
}
